/**
 * Kept as a mount point only. It used to call `get_current_user_tenant_id` to log that the database
 * answered, a second copy of the lookup AuthContext already makes, so every screen paid for one more
 * round trip at load.
 */
export function AuthInitializer() {
  return null;
}
